module.exports = __webpack_public_path__ + "media/duck.e623a07a.mp3";